export const DEFAULT_LIBRARY_URL = '/library';
export const CANONICAL_BASE_URL = 'https://www.osmosis.org';
export const SCROLL_TOP_CLASSNAME = 'library-box-scroll-top';
export const ENCODED_HASH = '%23';
